import { useCallback, useEffect, useRef } from 'react';

/**
 * Una respuesta solo cuenta si es la de la ÚLTIMA petición de su tipo y la pantalla sigue montada.
 * Sin esto, una respuesta que llega tarde pisa a una más nueva (dos recargas seguidas que terminan
 * en el orden contrario), o escribe en una pantalla que ya no está.
 *
 * Cada llamada a la función que devuelve abre una petición y entrega su «¿sigo vigente?»:
 *
 *   const request = useRequestGuard();
 *   const load = () => { const isCurrent = request(); fetchIt().then((data) => { if (isCurrent()) setData(data); }); };
 *
 * Un guardián por dato: dos datos distintos no se invalidan entre sí.
 */
export function useRequestGuard(): () => () => boolean {
  const latest = useRef(0);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  return useCallback(() => {
    const mine = ++latest.current;
    return () => mounted.current && latest.current === mine;
  }, []);
}
